import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  resetForm,
  getAccountById,
  getFormConfig,
  modifyCustomField, //Groups
  modifyAccount,
  addAccount,
  updateAccount,
  addCustomField,
  removeCustomField,
} from 'accounts/actions';

import { getEditing } from 'accounts/selectors';
import { getCompany, getSubcompany } from 'auth/selectors';
import { addGrowlError, addGrowlSuccess } from 'messages/actions';

import { valueFromEvent, createRoute } from 'lib/util';
import { getCustomFieldsEmployees } from 'custom_fields_employees/actions'; //Groups
import { getGroups } from 'groups/actions'; //Groups

class AccountsFormHandlers extends Component {
  static propTypes = {
    render: PropTypes.func.isRequired,
  };

  state = { isSubmitted: false, isValid: false, isSaving: false };

  componentWillMount = () => {
    const { aid } = this.props.match.params;
    this.props.reset();
    this.props.getFormConfig(this.props.company.id, this.props.subcompany.id);
    aid && this.props.getById(aid, this.props.company.id, this.props.subcompany.id);
    //Groups
    this.props.getCustomFields(this.props.company.id, this.props.subcompany.id);
    const filters = { fulltext: 'cuentas_contables', columnSearch: ['module'] }; // Filtros para traer solo los grupos de empleados
    this.props.getGroups(this.props.company.id, this.props.subcompany.id, filters);
    //Groups
  };

  handleSubmit = ({ isValid }) => {
    this.setState({ isSubmitted: true, isValid, isSaving: true }, () => {
      if (isValid) {
        const promise = this.props.account.id
          ? this.props.update(
              this.props.account.id,
              this.props.company.id,
              this.props.subcompany.id,
              this.props.account
            )
          : this.props.add(this.props.company.id, this.props.subcompany.id, this.props.account);

        promise
          .then(({ value }) => {
            this.props.success(value.message);
            this.props.history.push(
              createRoute(this.props.company.id, this.props.subcompany.id, 'accounts')
            );
          })
          .catch((err) => {
            this.props.error(err.message);
            this.finishSaving();
          });
      } else {
        this.props.error('error.verify');
        this.finishSaving();
      }
    });
  };

  finishSaving = () => this.setState({ isSaving: false });

  handleValueChange = (e) => this.props.modify(valueFromEvent(e));

  //Groups
  handleGroupChange = (e) => {
    const { value } = e.target;
    let _group = [{ _id: value }];
    if (value == 'null' || value == '' || value == null || value == undefined) _group = [];
    this.props.modify({ _group });
  };

  handleCustomFieldChange = (e) => this.props.modifyCustomField(valueFromEvent(e)); // Especial para custom fields
  //Groups

  handleValidation = (isValid) => this.setState({ isValid });

  handleAddCustomField = () => this.props.addCustomField();

  handleRemoveCustomField = (index) => this.props.removeCustomField(index);

  render = () =>
    this.props.render({
      isSaving: this.state.isSaving,
      isSubmitted: this.state.isSubmitted,
      handleAddCustomField: this.handleAddCustomField,
      handleRemoveCustomField: this.handleRemoveCustomField,
      handleSubmit: this.handleSubmit,
      handleCustomFieldChange: this.handleCustomFieldChange, //Groups
      handleGroupChange: this.handleGroupChange, //Groups
      handleValueChange: this.handleValueChange,
      handleValidation: this.handleValidation,
    });
}

const mapStateToProps = (state) => ({
  account: getEditing(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

const mapDispatchToProps = {
  add: addAccount,
  error: addGrowlError,
  getById: getAccountById,
  getFormConfig,
  modify: modifyAccount,
  getCustomFields: getCustomFieldsEmployees, //Groups
  getGroups: getGroups, //Groups
  modifyCustomField: modifyCustomField, //Groups
  reset: resetForm,
  success: addGrowlSuccess,
  update: updateAccount,
  addCustomField,
  removeCustomField,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AccountsFormHandlers));



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/containers/AccountFormHandlers.js